export default __webpack_public_path__ + "static/404-dsk-808503d79d1f81531cdd9a6db0e198a7.png";